import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupUnion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"boolean-group-union"} maskId="square-filled-radius-0-stroke-1-IconBooleanGroupUnion"><path d="M8 2V8H2V22H16V16H22V2H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBooleanGroupUnion;
